import type { SavedView } from '@queries/fetchSavedViews';
import { useSavedViews } from '@queries/fetchSavedViews';

import { useSavedViewsEnabled } from './useSavedViewsEnabled';
import { useSavedViewUrlId } from './useSavedViewUrlSelection';

export const useActiveSavedView = (): SavedView | null => {
  const enabled = useSavedViewsEnabled();
  const activeViewId = useSavedViewUrlId();
  const { data: views = [] } = useSavedViews(enabled);

  // A disabled query can still serve a warm cache — gate the resolution, not just the fetch.
  return (enabled && views.find((v) => v.id === activeViewId)) || null;
};

export const useIsSavedViewActive = (): boolean => useActiveSavedView() !== null;
